import { createFileRoute } from "@tanstack/react-router";
import { InvalidInvitation, InvitationScreen } from "@/features/onboarding/InvitationScreen";
import { inviteQuery } from "@/lib/api/queries";

/** An invitation link. Signed out is fine here: the token is the credential. */
export const Route = createFileRoute("/invite/$token")({
  loader: ({ context, params }) => context.queryClient.ensureQueryData(inviteQuery(params.token)),
  component: Invitation,
  errorComponent: InvalidInvitation,
});

function Invitation() {
  return <InvitationScreen token={Route.useParams().token} />;
}
